import { Location } from '@angular/common';
import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { CompanyParamsService } from 'src/app/core/services/company-params.service';

@Component({
    selector: 'app-access-not-granted',
    templateUrl: './access-not-granted.component.html',
    styleUrls: ['./access-not-granted.component.scss']
})
export class AccessNotGrantedComponent implements OnInit {
  counter: number = 10;
  POSITION_COMPANY_NAME = 1;
  companyName = this.location.path().split('/')[this.POSITION_COMPANY_NAME];
  constructor(
    private location: Location,
    private router: Router,
    @Inject(PLATFORM_ID)
    private platformId: any,
    public companyParamsService: CompanyParamsService
  ) { }
  ngOnInit() {
    this.goHome();
    this.setScript();
  }
  goHome() {
    setInterval(() => {
      this.counter--;
      if (this.counter === 0) {
        this.router.navigate([this.companyName]);
      }
    }, 1000);
  }
  public setScript() {
    if (isPlatformBrowser(this.platformId)) {
      this.companyParamsService.getScripts().forEach((item) => {
        var head = document.createElement('script');
        head.type = 'text/javascript';
        head.src = item.srcLinks;
        document.head.appendChild(head);
      });
    }
  }
}
